import { h } from "vue";
import type { IconAliases, IconProps, IconSet } from "vuetify";
import { DSIcon } from "@/src/design_system";
import { ICONS } from "@/src/design_system/primitives/icon/constants/icons";
import type { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import { ICON_COMPONENTS_MAP } from "@/src/easy-icons/constants/icons";

const aliases: IconAliases = {
  calendar: "calendar",
  cancel: "cancel",
  checkboxIndeterminate: " ",
  checkboxOff: "checkboxOff",
  checkboxOn: "checkboxOn",
  clear: "clear",
  close: "close",
  collapse: "collapse",
  complete: "complete",
  copy: "copy",
  cyborg: "cyborg",
  delete: "delete",
  delimiter: "delimiter",
  dropdown: "dropdown",
  edit: "edit",
  error: "error",
  expand: "expand",
  file: "file",
  first: "first",
  importAlt: "importAlt",
  info: "info",
  last: "last",
  loading: "loading",
  menu: "menu",
  minus: "minus",
  next: "next",
  plus: "plus",
  prev: "prev",
  radioOff: "radioOff",
  radioOn: "radioOn",
  ratingEmpty: "ratingEmpty",
  ratingFull: "star",
  ratingHalf: " ",
  refresh: "refresh",
  search: "search",
  sort: "sort",
  sortAsc: "sortAsc",
  sortDesc: "sortDesc",
  subgroup: "subgroup",
  success: "success",
  unfold: "unfold",
  warning: "warning",
  unlink: "unlink",
  user: "user",
  users: "users",
  digitalKey: "digitalKey",
  treeviewCollapse: "minus",
  treeviewExpand: "plus",
  eyeDropper: "eye",
  upload: "upload",
  color: "palette",
  command: " ",
  ctrl: " ",
  space: " ",
  shift: " ",
  alt: " ",
  enter: " ",
  arrowup: " ",
  arrowdown: " ",
  arrowleft: " ",
  arrowright: " ",
  backspace: " ",
};

const easyIconSet: IconSet = {
  component: (props: IconProps) => {
    const icon = String(props.icon ?? "").trim();
    const resolvedIcon = (ICON_COMPONENTS_MAP[icon as keyof typeof ICON_COMPONENTS_MAP] || icon) as string;

    if (!icon) {
      return h("span");
    }

    if (ICONS.includes(resolvedIcon as DSIconName)) {
      return h(DSIcon, {
        icon: resolvedIcon as DSIconName,
      });
    }

    return h("i", {
      class: `icon icon--${resolvedIcon}`,
    });
  },
};

export { easyIconSet, aliases };
